import { RouteConfig } from 'vue-router'

const partnerRoutes: Array<RouteConfig> = [
  {
    path: '/insurance-partner/orders',
    name: 'insurance-partner/view-orders',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewOrders.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin', 'insurance_partner']
    }
  },
  {
    path: '/insurance-partner/orders/:insuranceCode',
    name: 'insurance-partner/view-order-detail',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewOrderDetail.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin', 'insurance_partner']
    }
  },
  {
    path: '/insurance-partner/hospitals',
    name: 'insurance-partner/view-hospitals',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewHospitals.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/insurance-partner/vehicle-types',
    name: 'insurance-partner/view-vehicle-types',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewVehicleTypes.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/insurance-partner/vehicle-engines',
    name: 'insurance-partner/view-vehicle-engines',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewVehicleEngines.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/insurance-partner/vehicle-profiles',
    name: 'insurance-partner/view-vehicle-profiles',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewVehicleProfiles.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/insurance-partner/health-profiles',
    name: 'insurance-partner/view-health-profiles',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewHealthProfiles.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/insurance-partner/package-groups',
    name: 'insurance-partner/view-package-groups',
    component: () => import(/* webpackChunkName: "insurancePartner" */ '@/views/insurance-partner/PageViewPackageGroups.vue'),
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  }
]

export const insuranceRoutes = [...partnerRoutes]
